module.exports = __webpack_public_path__ + "img/svn.31fbdc5b.svg";